var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKeychain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1206 7.18183C13.1206 7.18183 9.2122 5.31154 9.04436 4.56822C8.87651 3.82491 13.9119 3.56115 20.9855 5.64723C28.059 7.73332 29.3299 9.41178 29.4737 9.6036C29.6895 9.89134 29.7855 10.3709 28.5146 10.6826",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5299 3.60855L21.465 2.67341C21.465 2.67341 22.1844 1.95406 22.7598 1.76224C23.3353 1.57042 24.4863 1.54644 24.4863 1.54644L34.2214 1.52246C34.2214 1.52246 35.732 1.57042 36.4034 2.26578C37.0508 2.96114 37.0748 4.11209 37.0748 4.11209L37.3146 13.3916C37.3146 13.3916 37.3146 14.9501 36.9789 16.1251C36.6432 17.3 35.708 18.0673 35.708 18.0673L16.5735 37.2017C15.7342 38.041 14.3915 38.041 13.5522 37.2017L1.73099 25.3806C0.891754 24.5413 0.891754 23.1986 1.73099 22.3593L18.9953 5.09518",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4948 24.6616L25.0136 36.8424C24.3902 37.8495 23.0954 38.1612 22.0883 37.5378L20.3379 36.4588",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.922 22.7431C11.922 22.7431 10.819 24.8052 12.3056 25.9801C13.7923 27.179 15.4468 26.5556 15.9983 25.7164C16.5498 24.8771 16.7416 23.6303 15.9263 22.1197C14.9912 20.3933 15.135 19.4341 16.1901 18.4271C17.2451 17.42 18.8756 17.9715 19.571 18.6189C20.2424 19.2663 20.6021 20.7769 19.7868 21.9998",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5706 18.6189L20.3139 17.8516",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5859 26.7473L12.3053 25.98",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9699 6.6543C30.7443 6.6543 32.183 8.09298 32.183 9.86735C32.183 11.6417 30.7443 13.0804 28.9699 13.0804C27.1955 13.0804 25.7568 11.6417 25.7568 9.86735C25.7568 9.02812 26.0686 8.2848 26.5961 7.70933",
    stroke: "#4C4C4C",
    strokeWidth: 1.54623,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeychain);
export default __webpack_public_path__ + "static/media/icon_keychain.6546d121eeb5762b470599ddb597a714.svg";
export { ForwardRef as ReactComponent };